<template>
    <div>
        <div v-for="(order, page_index) in printData" :key="'page_' + page_index">
            <div style="
                width:100%;
                justify-content: center;
                page-break-after: always;
                box-sizing:border-box;
                display:flex;
                min-height:220mm;position:relative;
                padding: 20px;
                "
                class="page"
            >
                <table style="width:100%;border-collapse: collapse">
                    <thead>
                        <tr style="padding-bottom:10px">
                            <th colspan="5">
                                <div style="display:flex;width:100%">
                                    <div style="display:inline-flex;flex-basis:50%;flex-direction:column">
                                        <div style="display:flex;flex-direction:column">
                                            <div style="display:inline-flex;">
                                                <img :src="company.profile" alt="" style="max-height:100px;max-width:100px">
                                            </div>
                                            <div style="display:inline-flex;flex-direction:column;margin-left:10px">
                                                <div style="display:flex;font-weight:900;font-size:18px;text-align:left">{{ company.name }}</div>
                                                <div style="display:flex;font-size:14px">สำนักงานใหญ่</div>
                                                <div style="display:flex;font-size:14px;text-align:left">{{ company.address }} {{ company.city }} {{ company.county }} {{ company.province }} {{ company.postcode }}</div>
                                                <div style="display:flex;font-size:14px;text-align:left">{{ company.tel }}</div>
                                                <div style="display:flex;font-size:14px;text-align:left">เลขประจำตัวผู้เสียภาษี {{ company.taxid }}</div>
                                            </div>
                                            <div style="display:flex;font-weight:800;font-size:18px;width:100%;margin-top:10px">
                                                ผู้ขาย
                                            </div>
                                            <div style="display:inline-flex;flex-direction:column">
                                                <div style="display:flex;font-weight:900;font-size:16px;text-align:left">{{ order.supplierName }}</div>
                                                <div style="display:flex;font-size:14px;text-align:left">{{ order.supplierAddress }}</div>
                                                <div style="display:flex;font-size:14px;text-align:left" v-if="order.supplierTaxId">เลขประจำตัวผู้เสียภาษี {{ order.supplierTaxId }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div style="display:inline-flex;flex-basis:50%;flex-direction:column">
                                        <div style="display:flex;width:100%;border-bottom:1px solid black;width:100%;flex-direction:column">
                                            <div style="display:flex;justify-content: flex-end;font-size:24px;font-weight:bold">ใบคืนของ/ใบรับของ</div>
                                            <div style="display:flex;justify-content: flex-end;font-size:20px;padding-top:10px;padding-bottom:10px">ต้นฉบับ (เอกสารออกเป็นชุด)</div>
                                        </div>
                                        <div style="display:flex;flex-direction:column;width:100%;margin-top:10px">
                                            <div style="display:flex">
                                                <div style="display:inline-flex;flex-basis:25%"></div>
                                                <div style="display:inline-flex;flex-basis:25%">เลขที่</div>
                                                <div style="display:inline-flex;flex-basis:50%">{{ order.orderNumber }}</div>
                                            </div>
                                            <div style="display:flex;padding-top:5px;">
                                                <div style="display:inline-flex;flex-basis:25%"></div>
                                                <div style="display:inline-flex;flex-basis:25%">วันที่คืน</div>
                                                <div style="display:inline-flex;flex-basis:50%">{{ order.createdAt }}</div>
                                            </div>
                                            <div style="display:flex;padding-top:5px;">
                                                <div style="display:inline-flex;flex-basis:25%"></div>
                                                <div style="display:inline-flex;flex-basis:25%">โดย</div>
                                                <div style="display:inline-flex;flex-basis:50%">{{ order.creator }}</div>
                                            </div>
                                            <div style="display:flex;padding-top:5px;">
                                                <div style="display:inline-flex;flex-basis:25%"></div>
                                                <div style="display:inline-flex;flex-basis:25%">จากคลัง</div>
                                                <div style="display:inline-flex;flex-basis:50%">{{ order.warehouseName }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                        <tr style="">
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:5%">#</th>
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:10%">รูป</th>
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:30%">ชื่อสินค้า</th>
                            <th style="border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px;width:10%">จำนวนคืน</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(product,index) in order.orderItems" :key="'product_' + index">
                            <td style="text-align:center">{{ index + 1 }}</td>
                            <td style="text-align:center">
                                <img :src="product.imageURL" alt="" style="max-width:100px;max-height:100px">
                            </td>
                            <td>
                                {{ product.name }}
                                <div style="opacity:0.8;font-size:14px">{{ product.sku }}</div>
                                <div style="font-size:14px" v-if="product.note">
                                    หมายเหตุ : {{ product.note }}
                                </div>
                            </td>
                            <td style="text-align:right">{{ product.quantity }} {{ product.unit }}</td>
                        </tr>
                        <template v-if="5 - order.orderItems.length > 0">
                            <tr v-for="pd in 5 - order.orderItems.length" :key="'temp_' + pd">
                                <td colspan="5" style="padding-top:50px;padding-bottom:50px"></td>
                            </tr>
                        </template>
                        <tr>
                            <td colspan="5">
                                <div style="display:flex;width:100%;page-break-inside:avoid;flex-direction:column;margin-top:auto">
                                <div style="display:flex;width:100%;border-top: 1px solid black;border-bottom: 1px solid black;padding-top:10px;padding-bottom:10px"></div>
                                <div style="display:flex;width:100%">
                                    หมายเหตุ : {{ order.note }}
                                </div>
                            </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    printData: {
      required: true,
      default: [],
    },
    company: {
      required: true,
      default: {},
    },
  },
}
</script>
